'use strict';

var tealium = require('../tealium');

var common = {
    init: function (){
    	$(document.body).off('click','.fo-social a').on('click','.fo-social a', function(e){
        	var obj = {
        		event_name:"social-fanpage",
        		social_network:$(this).attr('title'),
        		social_target:window.location.href
        		};
        	tealium.triggerEvent(obj);    		
    	}); 
    	$("body").off("click",".brand-logos a,.brands-list .sub-brands").on("click",".brand-logos a,.brands-list .sub-brands",function(){
    		var $curObj = $(this),
    			entryBrand = $curObj.data("brandname"),
    			exitBrand = $(".header-mian-banner").find(".primary-logo").data("brandname");
        	var brandVal = exitBrand + ':' + entryBrand;
        	var obj = {
        		event_name:"internal_brandExit",
        		exit_brand:brandVal
            };
        	tealium.triggerEvent(obj);
    	});
         $("body").off("click",".you-may-like a.name-link").on("click",".you-may-like a.name-link",function(){
        	var $this = $(this);
        	var _href = $this.attr("href");
        	var engine = "";
        	if(_href.indexOf("?") != -1){
        		$this.attr("href",_href + "&rrec=true");
        	}else {
        		$this.attr("href",_href + "?rrec=true");
        	}
        	MERCH_UTILS.setProductFindingMethodCookie("recommendation");
        	if(typeof (utag_data.product_id) !== 'undefined' && typeof (utag_data.page_type) !== 'undefined' && utag_data.page_type === "pdp"){
        		MERCH_UTILS.setCookie("_recommendingId",utag_data.product_id.join(":"));
        	}
            else {
                MERCH_UTILS.setCookie("_recommendingId","");
            }
            if ($(this).parentsUntil(".you-may-like").hasClass("at-recommendation")) {
                MERCH_UTILS.setCookie("_recommendingEngine","adobe target");
                engine = "adobe target";
            }
        	else if ($(this).parentsUntil(".you-may-like").hasClass("einstien-recommendations")){
                MERCH_UTILS.setCookie("_recommendingEngine","einstein");
                engine = "einstein";
            } else{
                MERCH_UTILS.setCookie("_recommendingEngine","adobe target");
                engine = "adobe target";
            }
        	if(utag && typeof (utag_data.page_type) !== 'undefined'){
        		var page = utag_data.page_type;
				var headingTextElem = $(this).closest(".recommendation").find(".recommendation-heading").eq(0);
				var headingText = $.trim(headingTextElem.text());
				if (headingTextElem.length === 0) {
					headingText = "you may also like";
			   	}
        		var location="";
				var recommendationPosition = $(this).closest(".you-may-like").attr("data-rec-location");
        		if($(".cart-overlay-html").find(".add-to-cart-rec").length > 0) {
        			headingText = $('body').find('.cart-overlay ').find(".recommendation-heading").text();
        			location = engine + ":" + headingText + ":add to bag overlay:main list";
        		} else if(page == "pdp"){
        			location = engine + ":" + headingText + ":" + page + ":" + recommendationPosition;        			
        		} else if(page == "cart"){
        			location = engine + ":" + headingText + ":" + page + ":" + recommendationPosition;
        		} else if(page == "confirmation"){
        			location = engine + ":" + headingText + ":order" + page + ":" + recommendationPosition;
        		} else {
        			location = engine + ":" + headingText + ":" + page + ":"+ recommendationPosition;
        		}
        		MERCH_UTILS.setCookie("_recommendingLocation",location);
        	}	
        }); 
          $("body").off("click",".last-visited-section a.name-link").on("click",".last-visited-section a.name-link",function(){
        	  MERCH_UTILS.setProductFindingMethodCookie("recommendation");
        	if(typeof (utag_data.product_id) !== 'undefined' && typeof (utag_data.page_type) !== 'undefined' && utag_data.page_type === "pdp"){
        		MERCH_UTILS.setCookie("_recommendingId",utag_data.product_id.join(":"));
        	}
            else {
                MERCH_UTILS.setCookie("_recommendingId","");
            }
        	MERCH_UTILS.setCookie("_recommendingEngine","default");
        	var page = utag_data.page_type;
        	var location="";
        	if(page == "pdp"){
        		location = "adobe target:recently viewed:" + page + ":bottom of page";
        	} else if(page == "cart"){
        		location = "default:recently viewed:" + page + ":bottom of page";
        		MERCH_UTILS.setCookie("_recommendingId","");     		
        	} else {
        		location = "default:recently viewed:"+page;
        		MERCH_UTILS.setCookie("_recommendingId","");    		
        	}
        	MERCH_UTILS.setCookie("_recommendingLocation",location);	       		
        }); 
        $("body").off("click",".home-content-1 a").on("click",".home-content-1 a",function(){			
			if($(this).hasClass("name-link") && $(this).closest('.you-may-like').length > 0) {
				return false;
			}
        	if(typeof (MERCH_UTILS) !== 'undefined') {
        		MERCH_UTILS.setProductFindingMethodCookie("browse");
        		MERCH_UTILS.setCookie("_productNavigation","");
        	}
        });
		$(document).on('click', 'ul.menu-category', function(e) {
			if($(window).width() > 1023) e.preventDefault();
			var href = $(this).attr('href');
			try{
				if(typeof (MERCH_UTILS) !== 'undefined') {
					MERCH_UTILS.setCookie("_productNavigation","tn:");
					MERCH_UTILS.setProductFindingMethodCookie("browse");
				}
			} catch(e) {
				console.log("Navbar click error", e.message);
			} finally {
				if($(window).width() > 1023) window.location.href = href;
			}
        });
        $("body").off("click","ul#category-level-2").on("click","ul#category-level-2 a",function(e){
			e.preventDefault();
			var href = $(this).attr('href');
			try{
				if(typeof (MERCH_UTILS) !== 'undefined') {
					MERCH_UTILS.setCookie("_productNavigation","ln:");
					MERCH_UTILS.setProductFindingMethodCookie("browse");
				}
			} catch(e) {
				console.log("breadcrumb click error", e.message);
			} finally {
				window.location.href = href;
			}
        });
        $("body").off("click",".breadcrumb a.breadcrumb-element").on("click",".breadcrumb a.breadcrumb-element",function(e){
			e.preventDefault();
			var href = $(this).attr('href');
			try{
				if(typeof (MERCH_UTILS) !== 'undefined') {
					MERCH_UTILS.setCookie("_productNavigation","bc:");
					MERCH_UTILS.setProductFindingMethodCookie("browse");
				}
			} catch(e) {
				console.log("breadcrumb click error", e.message);
			} finally {
				window.location.href = href;
			}
        });
        $("body").off("click",".search-suggestion-wrapper").on("click",".search-suggestion-wrapper",function(){
        	if(typeof (MERCH_UTILS) !== 'undefined') {   		
        		MERCH_UTILS.setProductFindingMethodCookie("site_search");
        	}			
		});
		
		$('form.simpleSearch').on("submit",function(e) {
            if(typeof (MERCH_UTILS) !== 'undefined') {   		
                MERCH_UTILS.setProductFindingMethodCookie("site_search");
            }
        	return true;
      	});
		
		/* code for complete the look carousel section*/
		 $("body").off("click",".complete-the-look a.name-link").on("click",".complete-the-look a.name-link",function(){
	        	var $this = $(this);
	        	var _href = $this.attr("href");
	        	if(typeof (MERCH_UTILS) !== 'undefined' && _href && _href !=''){
	        		MERCH_UTILS.setProductFindingMethodCookie("complete_the_look");
	        	}
	        }); 

		$('body').off('click','.slider-menu .globale-selector,#sfcc-nanobar-container .globale-selector, .header-country-selector-container .globale-selector').on('click','.slider-menu .globale-selector,#sfcc-nanobar-container .globale-selector,.header-country-selector-container .globale-selector',function(){
			var eventData = {
				"event_name": "international_shipping", 
				"location": utag_data && utag_data.page_type ? utag_data.page_type : '',
			};
			tealium.triggerEvent(eventData);
		});
		
    }
}


exports.init = common.init;
